import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ReadyToStart.css';

const ReadyToStart = () => {
  const navigate = useNavigate();

  const handleExploreClick = () => {
    navigate('/departments');
  };

  return (
    <div className="ready-to-start">
      <h2>Ready to start learning?</h2>
      <p>Take the first step in your learning journey with CriticalRiver Academy</p>
      <button className="btn-explore" onClick={handleExploreClick}>
        Explore All Courses
      </button>
    </div>
  );
};

export default ReadyToStart;
